import { FILTER_SELECT_EMPLOYEE } from "../../../../enums/Employees/employees.types";

export const filterSelectEmployeeAction = (uid) => {
    return {
        type: FILTER_SELECT_EMPLOYEE,
        payload: uid,
    };
};